import { Toaster } from "sonner";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";

export const SiteLayout = ({ children }) => {
  return (
    <div className="bg-white text-[#0a0a0a] min-h-screen">
      <Navbar />
      <main>{children}</main>
      <Footer />
      <Toaster
        theme="light"
        position="top-center"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid rgba(0,0,0,0.12)",
            color: "#0a0a0a",
            fontFamily: "Manrope, sans-serif",
            borderRadius: "0",
          },
        }}
      />
    </div>
  );
};

export const SectionHeader = ({ overline, title, italic, kicker }) => (
  <div className="grid grid-cols-12 gap-6 mb-12 md:mb-16">
    <div className="col-span-12 md:col-span-3">
      <p className="font-mono-ui text-[11px] tracking-[0.3em] uppercase text-[#0a0a0a]">
        <span className="text-[#C8102E]">{overline}</span>
      </p>
    </div>
    <div className="col-span-12 md:col-span-9">
      <h2 className="font-display text-[#0a0a0a] text-[clamp(34px,5.5vw,76px)] leading-[1.02] tracking-[-0.02em]">
        {title}
        {italic && <><br /><span className="font-light text-black/45">{italic}</span></>}
      </h2>
      {kicker && (
        <p className="mt-6 max-w-2xl text-black/65 text-base md:text-lg leading-relaxed">{kicker}</p>
      )}
    </div>
  </div>
);

export const PageHeader = ({ overline, title, italic, kicker }) => (
  <section className="bg-white pt-32 md:pt-44 pb-12 md:pb-20 border-b border-black/10">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12">
      <p className="font-mono-ui text-[11px] tracking-[0.3em] uppercase text-[#C8102E]">{overline}</p>
      <h1 className="mt-6 font-display text-[#0a0a0a] text-[clamp(44px,9vw,140px)] leading-[0.92] tracking-[-0.03em]">
        {title}
        {italic && <><br /><span className="font-light text-black/45">{italic}</span></>}
      </h1>
      {kicker && (
        <p className="mt-8 max-w-2xl text-black/65 text-lg md:text-xl leading-relaxed">{kicker}</p>
      )}
    </div>
  </section>
);
